// The original review database is gone, so the showcase build ships without reviews.
// Rating badges and review sections are hidden while this is false.
export const HAS_REVIEWS = false
